import useAppStore from "@/context/store";
import { getBoardSuggestTags, getTags } from "@/services";
import useRequest from "@/utils/useReq";
import classNames from "classnames";
import { drop, take, uniq } from "lodash";
import { useCallback } from "react";
import HBMessage from "../HBMessage";
import HBTagInput from "../HBTagInput";
import styles from "./index.module.less";

// 组合标签列表
/**
 * 选取常用标签前五和原始标签前五共10个展示
  当原始标签不足5个时，使用常用标签补齐
  当常用标签不足5个时，使用原始标签补齐
  都不足五个时，展示所有标签
  展示顺序：常用标签展示靠前，原始标签靠后
 */
function composeTagArr(pinTags, oftenTags) {
  // 先合并去重, 然后再分开
  const uniqArr = uniq([...oftenTags, ...pinTags]);
  const pre = take(uniqArr, oftenTags.length);
  const after = drop(uniqArr, oftenTags.length);

  if (pre.length <= 5) {
    return take(uniq([...pre, ...after]), 10);
  } else {
    // 从常用标签中补齐10个展示
    if (after.length <= 5) {
      return [...take(pre, 10 - after.length), ...after];
    }

    // 各取5个展示
    return [...take(pre, 5), ...take(after, 5)];
  }
}

/**
 *
 * @param {{
 *  pin: IPin,
 *  value?: string[];
 *  onChange?: (value: string[]) => void;
 * }} param0
 * @returns
 */
export default function PinCreatorLabelSelect({ pin, value, onChange }) {
  const user = useAppStore((s) => s.user);
  const urlname = user?.urlname;
  const { tags: pinTags, board_id: boardId } = pin || {};

  const { data: tagRestlt } = useRequest(
    async () => {
      const tags = pinTags?.length ? pinTags : [];
      if (!boardId) {
        return take([...tags], 10);
      }
      let suggestTags = [];
      const oftenResult = await getTags({ urlname, sort: "often" });
      if (oftenResult?.recent?.length > 0) {
        const res = oftenResult?.recent?.map((item) => item.tag_name) || [];
        suggestTags = composeTagArr(tags, res);
      } else {
        const suggestResult = await getBoardSuggestTags({ board_id: boardId });
        suggestTags = composeTagArr(tags, suggestResult?.tags || []);
      }
      return {
        suggestTags,
        tags: oftenResult?.tags,
      };
    },
    {
      refreshDeps: [boardId, urlname, pinTags],
    }
  );

  const onValueChange = useCallback(
    (value) => {
      if (value && value.length > 10) {
        HBMessage.info("最多添加10个标签");
      }
      onChange && onChange(value.slice(0, 10));
    },
    [onChange]
  );

  return (
    <HBTagInput
      className={classNames(styles.select, {
        [styles.noSuggestTags]: !tagRestlt?.suggestTags?.length,
      })}
      placeholder="输入标签(最多10个)"
      suggestTags={tagRestlt?.suggestTags}
      allTags={tagRestlt?.tags}
      onChange={onValueChange}
      // open={false}
      tags={value}
      tagLabel={pinTags?.length ? "推荐" : "常用"}
      placement={"topRight"}
    />
  );
}
